export default [
    {
        path: '/admin/fixed-allowances',
        name: 'fixed-allowance',
        meta: { requiresAuth: true },
        component: () => import('@/pages/payroll/fixed-allowance/index.vue')
    }
]